export const notifications = {
  successDataUpdate: 'Los datos se han actualizado con éxito.',
  errorOnDataUpdate: 'Se produjo un error al actualizar los datos.',
  waitResponseIn24Hours:
    'Espera la respuesta a tu invitación dentro de las 24 horas.',
  workItemIsCanceled: 'La invitación ha sido cancelada.',
  notificationDeleted: 'La notificación ha sido eliminada.',
  noNotifications: 'No tienes notificaciones.',
  workInviteRejected: 'La invitación ha sido rechazada.',
  workStartOnArtistArrivalConfirm:
    'El trabajo comenzará cuando el club confirme tu llegada al lugar de trabajo.',
  giveResponseFormWorkItem:
    'Responde a la invitación dentro de las 72 horas. Después de ese plazo, la invitación se eliminará.',
  generalError: 'Algo salió mal, inténtalo más tarde.',
  passwordReseted: 'La contraseña se ha restablecido.',
  languageSwitched: 'El idioma ha cambiado.',
  invitationExpired: 'La invitación ha expirado.',
  linkIsCopied: 'El enlace se ha copiado.',
  accountIsVisible: 'La cuenta ahora es visible en la búsqueda.',
  hiringEnabled: 'La contratación de artistas está abierta.',
  hiringDisabled: 'La contratación de artistas está cerrada.',
  rejectedForReason: 'Rechazado por __var_0__.',
  profileDeleted: 'El perfil ha sido eliminado.',
  accountHiddenFromSearch:
    'La cuenta está oculta y ya no se muestra en la búsqueda de artistas.',
  registerRequestSended: 'Solicitud de registro enviada.',
  notFoundNotifications: 'No tienes notificaciones.',
  lastWorkDaySeted: 'La última fecha de trabajo se ha establecido.'
};
